import {OrganizationKey} from "./Organization";
import {UserKey} from "../auth/model/User";

export interface MembershipKey {
    id: string,
    membershipRole: MembershipRole,
    organizationKey: OrganizationKey
    userKey: UserKey
}

export  enum MembershipRole {
    ADMIN = "ADMIN",
    MEMBER = "MEMBER"
}